export default "__VITE_ASSET__BfJb5F12__"